export class RecaptchaNamespace {
  public static readonly LOGIN_VIA_PASSWORD: string = 'loginViaPassword';
  public static readonly GENERATE_OTP: string = 'generateOtp';
  public static readonly LOGIN_VIA_OTP: string = 'loginViaOtp';
  public static readonly SEND_FORGOT_PASSWORD: string = 'sendForgotPassword';
  public static readonly RESET_PASSWORD: string = 'resetPassword';
  public static readonly PASSWORD_EXPIRED: string = 'passwordExpired';
  public static readonly LOGIN_VIA_SSO: string = 'loginViaSso';
  public static readonly LOGIN_VIA_OIDC_SSO: string = 'loginViaOidcSso';
}
